import { useNavigate } from 'react-router-dom';

import './page-header.css';

import { Icon } from '../icon/icon';

export function PageHeader(props) {
    const navigate = useNavigate();

    return (
        <header className="page-header">
            <section className="logo-section">
                <Icon name="atea" class="logo" clicked={() => navigate("/")} />
                {props.name &&
                    <span className="product-name" onClick={() => navigate("/")}>
                        {props.name}
                    </span>
                }
            </section>
            {props.children &&
                <section>
                    {props.children}
                </section>
            }
            {props.menu &&
                <section className="menu-section">
                    {props.menu}
                </section>
            }
        </header>
    );
}